import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Flex, IconButton, Link as ChakraLink, List, ListItem, mode, Popover, PopoverContent, PopoverTrigger, Portal, useColorMode } from '@abb/uikit';
import { Check } from '@abb/uikit/icons/solid/general';
import { DotsGrid } from '@abb/uikit/icons/solid/general';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import AbbBusinessIcon from 'shared-components/icons/AbbBusinessIcon';
import ABBMarketIcon from 'shared-components/icons/ABBMarketIcon';
import BeyondBankingIcon from 'shared-components/icons/BeyondBankingIcon';
import { InternetBankingIcon } from 'shared-components/icons/internet-banking-icon';
import InvestmentIcon from 'shared-components/icons/InvestmentIcon';
export function DigitalBridgeMenu(param) {
    let { isLargerThanMd, isSomeApps } = param;
    const { colorMode } = useColorMode();
    const location = useLocation();
    const { t, i18n } = useTranslation('common');
    const links = [
        {
            to: '',
            title: 'menu.digital_bridge.internet_bank',
            icon: /*#__PURE__*/ _jsx(InternetBankingIcon, {}),
            isHidden: false
        },
        {
            to: 'invest',
            title: 'menu.digital_bridge.invest',
            icon: /*#__PURE__*/ _jsx(InvestmentIcon, {}),
            isHidden: false
        },
        {
            to: `digital-platform/${i18n.language}/b2b`,
            title: 'menu.digital_bridge.open_api',
            icon: /*#__PURE__*/ _jsx(AbbBusinessIcon, {}),
            isHidden: false,
            isExternal: true
        },
        {
            to: 'bank-plus',
            title: 'menu.digital_bridge.beyond_bank',
            icon: /*#__PURE__*/ _jsx(BeyondBankingIcon, {}),
            isHidden: false
        },
        {
            to: `trade-platform`,
            title: 'menu.digital_bridge.trade_platform',
            icon: /*#__PURE__*/ _jsx(ABBMarketIcon, {}),
            isHidden: false,
            isExternal: true
        }
    ];
    return /*#__PURE__*/ _jsxs(Popover, {
        placement: "bottom",
        children: [
            /*#__PURE__*/ _jsx(PopoverTrigger, {
                children: /*#__PURE__*/ _jsx(Flex, {
                    alignItems: "center",
                    children: /*#__PURE__*/ _jsx(IconButton, {
                        p: "10px",
                        bgColor: "transparent",
                        cursor: "pointer",
                        _hover: {
                            bg: 'transparent'
                        },
                        icon: /*#__PURE__*/ _jsx(DotsGrid, {
                            width: "20px",
                            height: "20px",
                            color: mode('#2D3748', 'white')({
                                colorMode
                            })
                        }),
                        "aria-label": "grid",
                        isRound: true,
                        ml: !isLargerThanMd && 'auto',
                        "data-test-id": "dots-grid"
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Portal, {
                children: /*#__PURE__*/ _jsx(PopoverContent, {
                    className: "popover",
                    cursor: "pointer",
                    color: "white",
                    mt: 6,
                    background: "semantic.surface.primary",
                    p: 4,
                    borderRadius: "28px",
                    borderColor: mode('#E3E4E8', '#282829')({
                        colorMode
                    }),
                    width: "284px",
                    boxShadow: "0px 12px 8px 0px #0000000A",
                    children: /*#__PURE__*/ _jsx(List, {
                        children: links.map((link)=>/*#__PURE__*/ _jsxs(Flex, {
                                _hover: {
                                    background: 'semantic.surface.secondary',
                                    textDecoration: 'none'
                                },
                                borderRadius: "12px",
                                w: "100%",
                                alignItems: "center",
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ _jsx(ListItem, {
                                        display: link.isHidden ? 'none' : 'block',
                                        children: /*#__PURE__*/ _jsxs(Box, {
                                            as: link.isExternal ? ChakraLink : Link,
                                            ...!link.isExternal && {
                                                to: `/${link.to}`
                                            },
                                            ...link.isExternal && {
                                                href: `/${link.to}`
                                            },
                                            display: "flex",
                                            alignItems: "center",
                                            w: "100%",
                                            gap: 3,
                                            borderRadius: "12px",
                                            p: 3,
                                            color: "semantic.onSurface.primary",
                                            children: [
                                                link.icon,
                                                /*#__PURE__*/ _jsx(Box, {
                                                    as: "span",
                                                    display: "block",
                                                    children: t(link.title)
                                                })
                                            ]
                                        })
                                    }),
                                    link.to && location.pathname.includes(link.to) || link.to === '' && !isSomeApps && /*#__PURE__*/ _jsx(Check, {
                                        w: "16px",
                                        h: "16px",
                                        fill: mode('black', 'white')({
                                            colorMode
                                        })
                                    })
                                ]
                            }, link.to))
                    })
                })
            })
        ]
    });
}
